import * as React from "react";
import { Container, Drawer, Stack, SxProps } from "@mui/material";
// import { useRouter } from "next/router";

import { useBreakpoint } from "../../../hooks/useBreakpoint";
import {
  // IDataFetching,
  TSetUrlParamsArgs,
  useXoraiaValue,
} from "../../../hooks/useXoraia";
import { TUseXElement, useXElement } from "../../../hooks/useXElement";
import { USE_SELECTED_INDEX } from "../../../hooks/useSelectedElement";
import { useSetRecoilState } from "recoil";
import { getValueOnBreakpoint } from "../../../lib/getValueOnBreakpoint";
import { clickHandler } from "../../../lib/clickHandler";

import { isEqual } from "lodash";
import { XElementConfig } from "../../../utils/interfaces/Elements/XElement.interfaces";
import {
  IXCategoryFilterProps,
  XCategoryFilterProps,
} from "../../../utils/interfaces/containers/XCategoryFilter.interfaces";
import FilterSide from "./FilterSide";
import GridSide from "./GridSide";
import { useArticles } from "../../../hooks/useArticles";
import { generateSide } from "../../../lib/generateSide";

const compareProps = (prevProps: any, nextProps: any) => {
  return isEqual(prevProps, nextProps);
};

// TODO SOLVE TEXT COLOR ISSUE
// todo solve font size issue
// todo solve seperator issue
// todo solve section gutter issue
// todo solve checkbox count issue

const XCategoryFilter: React.FC<XCategoryFilterProps> = React.memo(
  ({ config = {} as XElementConfig }) => {
    const [openFilter, setOpenFilter] = React.useState<boolean>(false);
    const [articlesCount, setArticlesCount] = React.useState<number>(0);

    const [urlParams, updateUrlParams] = React.useState<TSetUrlParamsArgs>({});

    // WE TRACK THE BREAK POINTS CHANGES
    const breakpoint = useBreakpoint();

    const { env } = useXoraiaValue();

    // WE ARE GETTING THE CURRENT ELEMENT FROM THE ATOM FAMILY
    const { xElement } = useXElement<TUseXElement<IXCategoryFilterProps>>(
      config.index
    );

    const { articles } = useArticles({
      limit: 8,
      ...xElement.dataFetching,
      ...urlParams,
    });

    const onChange = async (args: TSetUrlParamsArgs) => {
      try {
        updateUrlParams((old) => ({ ...old, ...args }));

        // TODO IMPLEMENT using useArticle ans props count
        setArticlesCount(20);
      } catch (error) {
        console.error("UPDATE_URL =>", error);
      }
    };

    // GARBING THE INDEX UPDATER FOR GENERAL USAGE
    const setSelectedElement = useSetRecoilState(USE_SELECTED_INDEX);

    // IF WE DONT HAVE THIS ELEMENT CONFIGS ADDED WE DON'T SHOW IT
    if (!xElement || Object.keys(xElement).length === 0) return null;

    // WE GET ALL DEVICES PROPS AS VALUE
    const { value } = xElement;

    // WE NOW USE THE CURRENT BREAKPOINT VALUE ON THIS ELEMENT
    const valueAtBreakPoint = getValueOnBreakpoint<IXCategoryFilterProps>(
      value as any,
      breakpoint
    );

    const devProps = {
      id: config.index,
      onClick: (e: any) => clickHandler(e, setSelectedElement, config.index),
      // ...(!xElement.childOf && dndProps),
    };

    const {
      padding, // TODO ADD THIS TO SETTINGs
      margin, // TODO ADD THIS TO SETTINGs
      bgColor,

      // columns = 3,
      // pageLimit = 20,
      containerMode = "FILL",
      filterPosition = "left",
      // fontFamily = DEFAULT_FONT_FAMILY,
      textColor = "#000000",
      fontSize = "16px",
      // primaryColor = MAIN_COLOR,
      // collapsible = true,
    } = valueAtBreakPoint;

    const style: SxProps = {
      // fontFamily,
      fontSize,
      color: textColor,
      bgcolor: bgColor,
      padding: generateSide("padding", padding),
      margin: generateSide("margin", margin),
    };

    const gridSide = (
      <GridSide
        {...valueAtBreakPoint}
        articles={articles}
        onChange={onChange}
        urlParams={urlParams}
        articlesCount={articlesCount}
        setOpenFilter={setOpenFilter}
      />
    );

    let filterSide = (
      <FilterSide
        {...valueAtBreakPoint}
        onChange={onChange}
        urlParams={urlParams}
      />
    );

    if (breakpoint === "tablet" || breakpoint === "mobile") {
      filterSide = (
        <Drawer
          anchor="left"
          style={{ width: valueAtBreakPoint.filterWidth }}
          open={openFilter}
          onClose={() => setOpenFilter(false)}
          PaperProps={{
            sx: { px: 2 },
          }}
        >
          {filterSide}
        </Drawer>
      );
    }

    let content = (
      <Stack
        id="XCategoryFilter_Container"
        direction="row"
        spacing={3}
        sx={style}
      >
        {filterPosition === "left" ? filterSide : gridSide}
        {filterPosition === "left" ? gridSide : filterSide}
      </Stack>
    );

    if (containerMode === "CENTER") {
      content = <Container>{content}</Container>;
    } else if (containerMode === "FILL") {
      content = <Container maxWidth={false}>{content}</Container>;
    }

    return (
      <Stack
        position="relative"
        {...(env === "dev" && devProps)}
        width="100%"
        // sx={{
        //   margin: generateSide("margin", margin),
        //   padding: generateSide("padding", padding),
        // }}
      >
        {content}
      </Stack>
    );
  },
  compareProps
);

export default XCategoryFilter;
